module.exports = __webpack_public_path__ + "static/media/magic_icon.a88a8122.svg";